<template>
	
  <div class="p-grid nested-grid tab-card">
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(true)" :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning}, {'clickable':efCycleRunning}]">
      <!-- <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning}]"> -->
        <div class="p-col-fixed p-text-center icon">
          <i v-if="efCycleRunning" :class="['cycle-spinner']"><span :class="cycles.icons[appliance.gamma][appliance.cycle.functionRunning].icon" style="font-size: 35px;"/></i>
        </div>
        <div class="p-col">
          <span v-if="efCycleRunning">{{$t('ef.phases['+appliance.cycle.phaseRunning+']')}}</span> 
          <span v-else>{{$t('ef.no_cycle_running')}}</span>
        </div>
        <div v-if="efCycleRunning" class="p-col-fixed p-text-right">
          <span>{{ efCyclePhaseNumber}}/{{appliance.cycle.cycleTotalPhases}}</span> 
        </div>
        <div class="param-cta">
          <i v-if="efCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(!efContinuousCycleRunning)" :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || efContinuousCycleRunning}, {'clickable':efCycleRunning && !efContinuousCycleRunning}]">
      <!-- <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || efContinuousCycleRunning}]"> -->
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-time_left" style="font-size: 35px"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.ef.remaining_time')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span>{{efRemainingTime}}</span> 
        </div>
        <div class="param-cta">
          <i v-if="efCycleRunning && !efContinuousCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(efAirSetpointEnabled)" :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || !efAirSetpointEnabled}, {'clickable':efCycleRunning && efAirSetpointEnabled}]">
      <!-- <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || !efAirSetpointEnabled}]"> -->
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-air_temp"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.ef.air_temp')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span v-if="efCycleRunning && efAirSetpointEnabled">{{$functions.temperature(efAirSetpoint, isCelsius)}}{{unit}}</span> 
          <span v-else>-{{unit}}</span>  
        </div>
        <div class="param-cta">
          <i v-if="efCycleRunning && efAirSetpointEnabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="parametersDialog(efCoreSetpointEnabled)" :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || !efCoreSetpointEnabled}, {'clickable':efCycleRunning && efCoreSetpointEnabled}]">
      <!-- <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || !efCoreSetpointEnabled}]"> -->
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-ef_probe" style="font-size: 35px"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.ef.core_temp')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span v-if="efCycleRunning && efCoreSetpointEnabled">{{$functions.temperature(efCoreSetpoint,isCelsius)}}{{unit}}</span> 
          <span v-else>-{{unit}}</span>  
        </div>
        <div class="param-cta">
          <i v-if="efCycleRunning && efCoreSetpointEnabled" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6" v-if="isExcellence">
      <div @click="parametersDialog(true)" :class="['p-grid', 'p-ai-center', !efCycleRunning? 'gray':'clickable']">
      <!-- <div :class="['p-grid', 'p-ai-center', !efCycleRunning? 'gray':'']"> -->
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-fan"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.ef.fan_level')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <span v-if="efCycleRunning">{{efFanLevel}}</span> 
          <span v-else>-</span> 
        </div>
        <div class="param-cta">
          <i v-if="efCycleRunning" class="pi pi-chevron-right" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <!-- <div @click="parametersDialog(!efContinuousCycleRunning)" :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning}, {'clickable':efCycleRunning}]"> -->
      <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning}]">
      <!-- <div :class="['p-grid', 'p-ai-center', {'gray':!efCycleRunning || efContinuousCycleRunning}]"> -->
        <div class="p-col-fixed p-text-center icon">
          <span class="icon-time_spent" style="font-size: 35px"/>
        </div>
        <div class="p-col">
          <span>{{$t('details.ef.time_since_start')}}</span>
        </div>
        <div class="p-col-fixed p-text-right" >
          <span>{{efTimeSinceStart}}</span> 
        </div>
        <div class="param-cta">
          <!-- <i v-if="efCycleRunning && !efContinuousCycleRunning" class="pi pi-chevron-right" /> -->
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6">
      <Sanigen :serialNumber="serialNumber" />
    </div>
    <div class="p-col-12 p-md-6">
      <div @click="onoffDialog" :class="['p-grid', 'p-ai-center', {'gray': onoffDisabled }, {'clickable': !onoffDisabled && !readOnlyMode}]">
        <div class="p-col-fixed p-text-center">
          <img :class="[{'fade':onoffDisabled}]" src="assets/irinox/icons/onoff.svg" alt="ON/OFF"/>
        </div>
        <div class="p-col">
          <span>{{$t('library.cycle.stop_button')}}</span>
        </div>
        <div class="p-col-fixed p-text-right">
          <img :class="[{'fade':onoffDisabled}]"  v-if="onoffDisabled" src="assets/irinox/icons/switched_off.svg" :alt="$t('library.cycle.stop_button')"/>
          <img :class="[{'fade':onoffDisabled}]" v-else src="assets/irinox/icons/switched_on.svg" :alt="$t('library.cycle.stop_button')"/>
        </div>
      </div>
    </div>
  </div>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.ef.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.ef.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.ef.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

  <IrinoxDialogDark :visible="dialog.stop" mode="confirm" 
    :leftB="$t('library.cycle.stop_dialog_cancel_button')" @click:left-button="() => {dialog.stop = false;}" 
    :rightB="$t('library.cycle.stop_dialog_ok_button')" @click:right-button="stopCycle" 
    :message="$t('library.cycle.stop_dialog')"
    icon="assets/irinox/icons/play_big.svg" />
  <IrinoxDialogDark :visible="dialog.stopSuccess" 
    mode="success" 
    :message="$t('library.cycle.stop_dialog_success')"
    :life="3000" 
    @update:visible="dialog.stopSuccess = $event" />

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Sanigen from '../Sanigen.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
import EventHubListenerService from '../../../service/EventHubListenerService';
import commands from "../../../../public/json/commands_ef.json"
import commands_usa from "../../../../public/json/commands_ef_usa.json"

export default {
    components: {
      IrinoxDialogDark,
      Sanigen,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          dialog: {
            error: false,
            blockingError: false,
            success: false,
            stop: false,
            stopSuccess: false,
          },
          setpoint: {
            airTemp: null,
            coreTemp: null,
            fan: null,
            humidity: null,
            phaseDuration: null
          },
          limits: {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        isExcellence: function() {
          return this.deviceTwin && this.deviceTwin.info && this.deviceTwin.info.package === 2;
          // return false;
        },
        onoffDisabled: function() {
          return !this.appliance.online || !this.efCycleRunning;
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        efCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1 && this.appliance.cycle && this.appliance.cycle.functionRunning!==0;
        },
        efContinuousCycleRunning: function() {
          return !this.appliance.cycle || !this.appliance.cycle.cycleTimeLeft || this.appliance.cycle.cycleTimeLeft<=0 || [0,4].includes(this.appliance.cycle.phaseRunning) || [3,4].includes(this.appliance.cycle.functionRunning);
          // return this.efCycleRunning && this.appliance.cycle.functionRunning && this.appliance.cycle.functionRunning==13;
        },
        efAirTemp: function() {
          return this.appliance.status && this.appliance.status.TCell ? this.appliance.status.TCell : null;
        },
        efCoreTemp: function() {
          return this.appliance.status && this.appliance.status.TCore ? this.appliance.status.TCore : null;
        },
        efIsCore: function() {
          return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        },
        efRemainingTime: function() {
          if(!this.efContinuousCycleRunning && !this.efIsCore) {
            try {
              let time = this.efCycleRunning && this.appliance.cycle && this.appliance.cycle.cycleTimeLeft ? this.appliance.cycle.cycleTimeLeft / 60 : null;
              //time in minutes
              if(time) {
                var hours = Math.floor(time / 60);
                time = time - hours * 60;
                var minutes = Math.floor(time);
                return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
              }
            } catch(err) {
              return "N/A";
            }
          }
          return "--h:--m";
        },
        efTimeSinceStart: function() {
          try {
            let time = this.efCycleRunning && this.appliance.cycle && this.appliance.cycle.timeSinceStart ? this.appliance.cycle.timeSinceStart / 60 : null;
            //time in minutes
            if(time) {
              var hours = Math.floor(time / 60);
              time = time - hours * 60;
              var minutes = Math.floor(time);
              return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
            }
          } catch(err) {
            return "N/A";
          }
          return "--h:--m";
        },
        efAirSetpoint: function() {
          return this.appliance.status && this.appliance.status.cellSetTemp ? this.appliance.status.cellSetTemp : null;
        },
        efCoreSetpoint: function() {
          return this.appliance.status && this.appliance.status.coreProbeSetTemp ? this.appliance.status.coreProbeSetTemp : null;
        },
        efAirSetpointEnabled: function() {
          console.log("efAirSetpointEnabled",this.limits.cellSetTempMin, this.limits.cellSetTempMax);
          return this.limits.cellSetTempMin!=null && this.limits.cellSetTempMax!=null;
        },
        efCoreSetpointEnabled: function() {
          return this.limits.coreProbeSetTempMin!=null && this.limits.coreProbeSetTempMax!=null && this.efIsCore;
        },
        efFanLevel: function() {
          return this.appliance.status && this.appliance.status.evapFanSetSpeed ? this.appliance.status.evapFanSetSpeed : null;
        },
        efCyclePhaseNumber: function() {
          return this.appliance.cycle.cyclePhaseNumber;
        },
        // limits: function() {
        //   if(this.efCycleRunning) {
        //     try {
        //       let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
        //       let p = f.phases[String(this.appliance.cycle.phaseRunning)];
        //       if(p) {
        //         let lim = this.$functions.clone(p);
        //         if(lim.cellSetTempMin) {
        //           lim.cellSetTempMin*=10;
        //         }
        //         if(lim.cellSetTempMax) {
        //           lim.cellSetTempMax*=10;
        //         }
        //         if(lim.coreProbeSetTempMin) {
        //           lim.coreProbeSetTempMin*=10;
        //         }
        //         if(lim.coreProbeSetTempMax) {
        //           lim.coreProbeSetTempMax*=10;
        //         }
        //         return lim;
        //       }
        //     } catch(err) {
        //       console.warn("Error parsing commands " + err);
        //     }
        //   }
        //   return {
        //       name: null,
        //       cellSetTempMin: null,
        //       cellSetTempMax: null,
        //       coreProbeSetTempMin: null,
        //       coreProbeSetTempMax: null,
        //       evapFanSetSpeedMin: null,
        //       evapFanSetSpeedMax: null,
        //       phaseDurationSetMin: null,
        //       phaseDurationSetMax: null
        //     };
        // }
        commands: function() {
          if(this.deviceTwin?.status?.setLimit === 2) {
            // console.log("Using USA commands for EF");
            return commands_usa;
          } else {
            // console.log("Using EU commands for EF");
            return commands;
          }
        }
    },
    watch: {
      'commands': 'updateLimits',
      'efCycleRunning': 'updateLimits',
      'appliance.cycle.functionRunning': 'updateLimits',
      'appliance.cycle.phaseRunning': 'updateLimits',
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    methods: {
      parametersDialog(enable) {
        if(!enable || !this.efCycleRunning) {
          return;
        }
        this.setpoint = {
          airTemp: this.efAirTemp,
          coreTemp: this.efCoreTemp,
          fan: this.efFanLevel,
          phaseDuration: null // ???
        };
        // if(this.appliance.cycleLibrary) {
        //   this.$router.push({ name: 'appliance-ef-cycle', params: { serialNumber: this.appliance.serialNumber }});
        // } else {
          this.$router.push({ name: 'appliance-ef-cycle-def', params: { serialNumber: this.appliance.serialNumber }});
        // }
      },
      // setSetpoint() {
      //   let data = {};
      //   if(this.setpoint.airTemp != null) {
      //     data.cellSetTemp = this.setpoint.airTemp;
      //   }
      //   if(this.setpoint.coreTemp != null) {
      //     data.coreProbeSetTemp = this.setpoint.coreTemp;
      //   }
      //   if(this.setpoint.fan != null) {
      //     data.evapFanSetSpeed = this.setpoint.fan;
      //   }
      //   if(this.setpoint.humidity != null) {
      //     data.setLevelHumidity = this.setpoint.humidity;
      //   }
      //   if(this.setpoint.phaseDuration != null) {
      //     data.phaseDurationSet = this.setpoint.phaseDuration;
      //   }

      //   this.dialog.fan = false;
      //   this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
      //     .then((data) => {
      //       if(data.code=="200") {
      //         this.dialog.success = true;
      //       } else {
      //         console.error("EXCEPTION "+JSON.stringify(data));
      //         this.dialog.error = true;
      //       }
      //     })
      //     .catch(error => {
      //       console.error("EXCEPTION "+error);
      //       this.dialog.error = true;
      //     });

      // }
      onoffDialog() {
        if(this.onoffDisabled || this.readOnlyMode) {
          return;
        }
        this.dialog.stop = true;
      },
      stopCycle() {
        // let recipeId = this.appliance.cycle.runningCycleId;
        // if(typeof recipeId === "number") {
        //   recipeId = "IRINOX_" + (recipeId).toString().padStart(8, '0');
        // }
        let stopCommand = {
          // id: recipeId,
          operationSet: 0
        };
        this.dialog.stop = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, stopCommand)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.stopSuccess = true;
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
      updateLimits() {
        if(this.efCycleRunning) {
          try {
            console.log("updateLimits", this.appliance.cycle.functionRunning, this.appliance.cycle.phaseRunning);
            let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
            let p = f.phases[String(this.appliance.cycle.phaseRunning)];
            if(p) {
              let lim = this.$functions.clone(p);
              if(lim.cellSetTempMin) {
                lim.cellSetTempMin*=10;
              }
              if(lim.cellSetTempMax) {
                lim.cellSetTempMax*=10;
              }
              if(lim.coreProbeSetTempMin) {
                lim.coreProbeSetTempMin = Math.max(lim.coreProbeSetTempMin*10, this.efAirSetpoint!=null ? this.efAirSetpoint : lim.coreProbeSetTempMin*10);
                // lim.coreProbeSetTempMin*=10;
              }
              if(lim.coreProbeSetTempMax) {
                lim.coreProbeSetTempMax*=10;
              }
              this.limits = lim;
              return;
            }
          } catch(err) {
            console.warn("Error parsing commands " + err);
          }
        }
        this.limits = {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          };

      },
    }
}
</script>

<style >

</style>